import {combineReducers} from "redux"
import {BasicInformationReducer, GetAllData, CreateQuestionReducer, QuestionScreenReducer} from "./reducer"
export default combineReducers(
    {
        CreateQuestionReducer:CreateQuestionReducer,
        QuestionScreenReducer:QuestionScreenReducer,
        BasicInformationReducer:BasicInformationReducer,
        GetAllData:GetAllData,
    }
)